<!--  -->
<template>
<div>
  <div class="banner">
      <div class="banner-text">
        <p class="title">{{$t('safety208')}}</p>
      </div>
    </div>
    <div class="banner-content">
        <p>{{$t('safety209')}}</p>
    </div>
  <div class="make-a-report">
    <div class="row-line">
      <h2 class="title">{{$t('safety210')}}</h2>
      <p class="content">{{$t('safety211')}}</p>
      <p class="content">{{$t('safety212')}} <br>{{$t('safety213')}} <br>{{$t('safety214')}}<br>{{$t('safety215')}}</p>
      <p>
        <span><img src="../assets/images/S9-1.png"/></span>
        <span><img src="../assets/images/S9-2.png"/></span>
        <span><img src="../assets/images/S9-3.png"/></span>
        <span><img src="../assets/images/S9-4.png"/></span>
      </p>
    </div>
    <div class="row-line">
      <h2 class="title">{{$t('safety216')}}</h2>
      <p class="content">{{$t('safety217')}}<a target="_blank" href="https://support.livu.me/hc/en-us/requests/new?ticket_form_id=360003918394">Send a report</a></p>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'make-a-report',
  data () {
    return {
    }
  },

  components: {},

  computed: {},

  methods: {}
}

</script>
<style lang='scss' scoped>
@import '@/assets/style/vars.scss';
@media (min-width: 750px) {
  .banner-content{
      padding: 50px;
      font-size: 18px;
      text-align: left;
    }
    .banner {
      width: 100%;
      height: 500px;
      background: url('../assets/images/banner-5.png') no-repeat;
      background-size:  100% 100%;
      .title{
        color: #ffffff;
        font-size: 45px;
        font-weight: bold;
        text-align: center;
        line-height: 400px;
        margin-bottom: 40px;
      }
    }
  .make-a-report {
    width: 1000px;
    margin: 70px auto;
    padding-bottom: 40px;
    .row-line {
      margin-bottom: 40px;
      text-align: left;
      .title {
        font-size: 40px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .content {
        font-size: 24px;
        color: #5e5e5e;
        margin-bottom: 20px;
        line-height: 28px;
      }
      .row-line-button {
        text-align: right;
        margin-top: 20px;
        &>a {
          display: inline-block;
          width: 282px;
          height: 60px;
          background-color: $primary;
          color: #fff;
          text-align: center;
          line-height: 60px;
          font-size: 24px;
          border-radius: 8px;
          text-decoration: none;
        }
      }
    }
    .red {
      color: #F94A27;
    }
  }
}
@media (max-width: 750px) {
  .banner-content{
    padding: 10px;
    font-size: 14px;
    text-align: left;
  }
  .banner {
    width: 100%;
    height: 150px;
    background: url('../assets/images/banner-5.png') no-repeat;
    background-size:  100% 100%;
    .banner-text {
      padding: 25px;
      p {
        margin-bottom: 10px;
        font-size: 14px;
        line-height: 18px;
        color: #5E5E5E;
      }
      .title {
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        line-height: 100px;
        margin-bottom: 20px;
      }
    }
  }
  .make-a-report {
    padding: 35px 25px;
    padding-bottom: 40px;
    .row-line {
      margin-bottom: 30px;
      text-align: left;
      .title {
        font-size: 22px;
        font-weight: bold;
        color: #333;
        margin-bottom: 15px;
      }
      img{
        width: 75px;
        height: 150px;
      }
      .content {
        font-size: 14px;
        color: #5e5e5e;
        margin-bottom: 10px;
        line-height: 18px;
      }
      .row-line-button {
        text-align: right;
        margin-top: 20px;
        &>a {
          display: inline-block;
          width: 100%;
          height: 35;
          background-color: $primary;
          color: #fff;
          text-align: center;
          line-height: 35px;
          font-size: 18px;
          border-radius: 5px;
          text-decoration: none;
        }
      }
    }
    .red {
      color: #F94A27;
    }
  }
}
</style>
